import React, { ReactNode, useState } from 'react';
import { segmentCase } from '@guildeducationinc/catalog-tools';
import { IconButton, Popover, Typography } from '@guildeducationinc/recess';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { trackEvent } from '@src/services/analytics';
import styles from './RoundIconButton.module.scss';

export interface Props {
	disabled?: boolean;
	popoverText?: string;
	icon: ReactNode;
	label: string;
	onClick: (e: React.MouseEvent) => void;
	selected: boolean;
	role?: string;
}

export const RoundIconButton: React.FC<Props> = ({
	disabled,
	popoverText,
	icon,
	label,
	onClick,
	selected,
	role = 'checkbox',
}) => {
	const [showPopover, setShowPopover] = useState(false);

	return (
		<div className={styles.interestContainer}>
			<button
				aria-checked={selected}
				aria-label={label}
				className={styles.buttonWrapper}
				data-selected={selected}
				disabled={disabled}
				onClick={onClick}
				role={role}
			>
				<div className={styles.iconContainer}>{icon}</div>
			</button>

			<Typography className={styles.label} variant='label1'>
				{label}
				{popoverText && (
					<Popover
						id={label}
						onOutsideClick={() => setShowPopover(false)}
						popoverContent={popoverText}
						show={showPopover}
						testid='interest-popover'
						triggerRefProp='forwardRef'
					>
						<IconButton
							appearance='minimal'
							className={styles.popoverIcon}
							icon={<InfoOutlinedIcon size={16} />}
							label={`More info about studying ${label}`}
							onClick={() => {
								setShowPopover(true);
								trackEvent('Clickable', {
									tag: 'quiz_interests',
									text: segmentCase(label),
									type: 'popover',
								});
							}}
						/>
					</Popover>
				)}
			</Typography>
		</div>
	);
};
